import React from "react";
import professionalsImg1 from "../../Assets/About/professionsImg1.svg";
import professionalsImg2 from "../../Assets/About/professionsImg2.svg";
import professionalsImg3 from "../../Assets/About/professionsImg3.svg";
import professionalsImg4 from "../../Assets/About/professionsImg4.svg";
import { useState, useEffect } from "react";
import axios from "axios";

const data = [
  {
    id: 1,
    name: "Aditya Mishra",
    role: "Massage Specialist",
    profileImage: professionalsImg1,
  },
  {
    id: 2,
    name: "Ditya Mishra",
    role: "Massage Specialist",
    profileImage: professionalsImg2,
  },
  {
    id: 3,
    name: "Aditya Mishra",
    role: "Massage Specialist",
    profileImage: professionalsImg3,
  },
  {
    id: 4,
    name: "Ditya Mishra",
    role: "Massage Specialist",
    profileImage: professionalsImg4,
  },
];
const OurProfessionals = () => {
  const [team, setTeam] = useState([]);
  const showTeam = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_KEY}/team/getTeamByBranchId/674586f39aa6780fb2688685`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response: ", response.data);
        setTeam(response?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    showTeam();
  }, []);
  return (
    <div className="my-8">
      <div className="flex justify-center items-center flex-col gap-2">
        <h5 className="lato-thin-italic text-[#FF8F61]">Our Team</h5>
        <h2 className="text-3xl md:text-5xl text-center font-serif font-semibold text-[#202020]">
          Our Professionals
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-7 md:mx-16">
        {team.map((item) => (
          <Card key={item?.id} professional={item} />
        ))}
      </div>
    </div>
  );
};

export default OurProfessionals;

function Card({ professional }) {
  return (
    <div
      key={professional?.id}
      className="flex flex-col items-center h-fit text-center  relative  "
    >
      <div>
        <img
          src={professional?.profilePic}
          alt={professional?.name}
          className="w-full h-full relative  object-cover"
        />
      </div>
      <div className="absolute  top-[80%]">
        <h3 className="text-[#2D2D2D] font-bold font-serif text-base md:text-lg">
          {professional?.name}
        </h3>
        <h4 className="text-[#595959] font-semibold  text-[10px] md:text-sm">
          {professional?.role}
        </h4>
      </div>
    </div>
  );
}
